import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Header from "./components/Header"
import Footer from "./components/Footer"
import HomePage from "./pages/HomePage"
import SubjectPage from "./pages/SubjectPage"
import BookmarksPage from "./pages/BookmarksPage"
import AboutPage from "./pages/AboutPage"
import "./App.css"
import MnemonicDetail from './pages/MnemonicDetail'; // Detail view
import { MathJaxContext } from "better-react-mathjax";

const config = {
  loader: { load: ["input/tex", "output/chtml"] }
};


function App() {
  return (
    <MathJaxContext config={config}>
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mnemonic/:id" element={<MnemonicDetail />} />
            <Route path="/physics" element={<SubjectPage subject="physics" />} />
            <Route path="/chemistry" element={<SubjectPage subject="chemistry" />} />
            <Route path="/math" element={<SubjectPage subject="math" />} />
            <Route path="/bookmarks" element={<BookmarksPage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </MathJaxContext>
  )
}

export default App
